import type { UsuarioLogado } from '../types/gmud'

/**
 * Quem pratica atos de fiscalização do contrato.
 *
 * Fechar o mês, dispensar sanção, registrar o valor da nota, medir a infraestrutura, imputar ponto
 * de IAD, conferir o mês, pedir a leitura de apoio: todos passam por
 * `@PreAuthorize(Autorizacoes.FISCAL)` no servidor, que é
 * `hasAnyRole('FISCAL', 'ADMIN') and hasAuthority('ORG_CONTRATANTE')`. Esta função é a mesma frase
 * escrita uma vez para a tela.
 *
 * **Isto não é a autorização.** A recusa de verdade é do servidor, e ela vale mesmo se esta função
 * errar. O que se evita aqui é oferecer um botão cuja única resposta possível é 403 — e o público
 * declarado do sistema é leigo em TI: quem clica em "Registrar" e recebe uma tarja vermelha não
 * conclui "eu não tenho permissão", conclui "eu quebrei o sistema". Era a divergência 9 do roteiro
 * de UAT, corrigida em `AcoesDaCompetencia` e em nenhum outro dos seis pontos.
 *
 * **Um critério, um lugar.** O sistema anterior chegou a quatro listas de permissão discordando
 * entre si — é a mesma razão pela qual `Autorizacoes` existe no servidor. Quem precisar da regra
 * chama esta função; ninguém reescreve `papeis.includes('FISCAL')` numa tela.
 *
 * **As duas chaves juntas, como no servidor.** O papel diz o que a pessoa faz; `papelContratual`
 * diz de que lado do contrato ela está. Um papel de fiscal concedido por engano a alguém da
 * contratada não pode oferecer o registro do valor da própria fatura.
 *
 * @param usuario quem está usando, ou nulo enquanto o `GET /me` não respondeu
 * @returns verdadeiro para fiscal ou administrador do lado da Prefeitura
 */
export function podeFiscalizar(usuario: UsuarioLogado | null): boolean {
  if (usuario?.papelContratual !== 'CONTRATANTE') {
    return false
  }
  return usuario.papeis.includes('FISCAL') || usuario.papeis.includes('ADMIN')
}
